import { useEffect } from 'react';

// Custom Hook für Contact-Button Event-Handling
export const useContactButtonHandler = (onContactClick: () => void) => {
  useEffect(() => {
    const handleContactButtonClick = (event: Event) => {
      const target = event.target as HTMLElement;
      
      // Prüfen ob das Element oder ein Parent das data-action="contact" Attribut hat
      const contactElement = target.closest('[data-action="contact"]');
      
      if (contactElement) {
        event.preventDefault();
        onContactClick();
      }
    };

    // Event-Listener zu document hinzufügen für Event-Delegation
    document.addEventListener('click', handleContactButtonClick);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleContactButtonClick);
    };
  }, [onContactClick]);
};

export default useContactButtonHandler;
